import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'
import { RelatedAlertsList } from './RelatedAlertsList'

interface Props {
  relatedAlertIds: readonly string[]
}

/**
 * "What else is going on with this customer" — surfaces sibling alerts so
 * analysts can spot mule-pattern clusters or repeat false-positive sources.
 *
 * Customer details live in the action rail (see CustomerSnapshotCard) — we
 * don't repeat them here. Tabs were dropped after the design review since
 * "Customer" was the same data twice.
 */
export function WhoTabs({ relatedAlertIds }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Related alerts ({relatedAlertIds.length})</CardTitle>
      </CardHeader>
      <CardContent>
        <RelatedAlertsList alertIds={relatedAlertIds} />
      </CardContent>
    </Card>
  )
}
